"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataLayerRawPush = void 0;
var constants_1 = require("../constants/constants");
var dataLayerConstructor_1 = require("./dataLayerConstructor");
/**
 * This function pushes `dataLayerProps` directly to the window.dataLayer object.
 * (it will also remove the existing 'em.pageView' events if any exist in `window.dataLayer`, unless specified otherwise).
 *
 * **ATTN**: to be used inside the useEffect() hook or client-side otherwise (it assumes the presence of `window` object)
 * @param dataLayerProps - Object - object with DataLayerProps (all will be formatted, cleaned and pushed into `window.dataLayer`)
 * @param removePrevious  _(optional)_ defaults to `true`. Set to `false` to keep existing (previously pushed) `em.pageView` events in `window.dataLayer`
 * @param enableLogging _(optional)_ set it to `true` to enable console logging
 */
var dataLayerRawPush = function (dataLayerProps, removePrevious, enableLogging) {
    if (removePrevious === void 0) { removePrevious = true; }
    if (enableLogging) {
        console.log('DATALAYER :: window.dataLayer (before new entry): ', window === null || window === void 0 ? void 0 : window.dataLayer);
    }
    // Ensure window.dataLayer exists
    window.dataLayer = window.dataLayer || [];
    // Find and remove all existing 'em.pageView' events one by one
    if (removePrevious) {
        var index = 0;
        while (index !== -1) {
            index = window.dataLayer.findIndex(function (obj) { return obj.event === constants_1.DATA_LAYER_EVENT_PAGE_VIEW; });
            // If found, remove the existing object
            if (index !== -1) {
                var removedDataLayerObject = window.dataLayer.splice(index, 1);
                if (enableLogging) {
                    console.log('DATALAYER :: removedDataLayerObject: ', removedDataLayerObject);
                }
            }
        }
    }
    // Add the new dataLayerProps object
    if (enableLogging) {
        console.log('DATALAYER :: incoming dataLayerProps: ', dataLayerProps);
    }
    window.dataLayer.push((0, dataLayerConstructor_1.getDataLayerProperties)(dataLayerProps));
};
exports.dataLayerRawPush = dataLayerRawPush;
//# sourceMappingURL=dataLayerRawPush.js.map